import { LocationModel, PersonModel, LocationNameModel, IsOwn, IsOwnCompany, PhoneNumberModel, CompanyDataModel, EmailModel } from "../common/models/CommonModels";
import * as moment from 'moment';
import { Moment } from "moment";
import { RecurrenceModel, getEmptyRecurrenceModel } from "../common/models/Recurrence";

export interface TruckModelBase<TLocation, TDate> extends IsOwn, IsOwnCompany {
    id: string;
    plateNumber: string;
    availableFrom: TDate;
    availableTo: TDate;
    carrierCompany: string;
    details: string;
    contractPrice?: number;
    properties: TruckProperties;
    departureCity: TLocation,
    destinationCity?: TLocation,
    createdBy: string;
    companyId: string;
    deletedAt?: TDate;
    isDistanceCheckEnabled: boolean;
    searchDistance: number;
}

export interface TruckModel extends TruckModelBase<LocationModel, moment.Moment> {
    reportNumber: string;
    carrierCompany: string;
    company: CompanyDataModel<PhoneNumberModel, EmailModel>;
    coordinator: PersonModel;
    recurrence: RecurrenceModel;
}

export interface AddNewTruckModel extends TruckModelBase<LocationNameModel, Moment> {
    noDestination: boolean;
    recurrence: RecurrenceModel;
}

export interface TruckProperties {
    adr: boolean;
    explosive: boolean;
    glass: boolean;
    tank: boolean;
    thermal: boolean;
    mega: boolean;
    container20: boolean;
    containerOver20: boolean;
    pieceGoods: boolean;
    bulkGoods: boolean;
    trailer: boolean;
}

export enum DeleteReason {
    FoundCargoForTruckFromThisApp = "FoundCargoForTruckFromThisApp",
    FoundCargoForTruckElsewhere = "FoundCargoForTruckElsewhere",
    ErrorTruckWasNotFree = "ErrorTruckWasNotFree",
    OtherReason = "OtherReason",
}

export interface DeleteTruckModel {
    id: string;
    reason?: DeleteReason;
    contractCompanyId?: string;
}

const getInitialProperties = () => <TruckProperties>{ trailer: true };

export const getEmptyDeleteTruckModel = (): DeleteTruckModel => {
    return {
        id: "",
        reason: undefined,
        contractCompanyId: ""
    }
};

export const getInitialModelValue = (): AddNewTruckModel => {

    const startDate = moment().add(1, "hours").minute(0).second(0).millisecond(0);

    return {
        id: "",
        departureCity: {
            id: "",
            name: ""
        },
        destinationCity: {
            id: "",
            name: ""
        },
        noDestination: false,
        availableFrom: startDate,
        availableTo: startDate.clone().add(1, "hours"),
        plateNumber: "",
        carrierCompany: "",
        details: "",
        createdBy: "",
        companyId: "",
        properties: getInitialProperties(),
        recurrence: getEmptyRecurrenceModel(startDate),
        isOwn: false,
        isOwnCompany: false,
        contractPrice: 0,
        isDistanceCheckEnabled: true,
        searchDistance: 50
    }
}



// WEBPACK FOOTER //
// ./src/trucks/TruckModels.ts